import React from "react";
import Slider from "react-slick";

function Reviewsandcomments({ productDetails, overall_ratting }) {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Helper function to render star ratings
  const renderStars = (reviewsvalue) => {
    const totalStars = 5;
    const filledStars = Array(reviewsvalue).fill("★"); // Filled stars
    const emptyStars = Array(totalStars - reviewsvalue).fill("☆"); // Empty stars

    return (
      <div
        style={{
          color: "#FFB258",
          fontSize: "24px",
          display: "flex",
          gap: "3px",
        }}
      >
        {filledStars.concat(emptyStars).map((star, index) => (
          <span key={index}>{star}</span>
        ))}
      </div>
    );
  };

  return (
    <>
      {productDetails?.review?.length > 0 ? (
        <section className="reviewsandcomments pt-40 pb-40">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h4 className="heading_two">Review & Comments</h4>
              </div>
            </div>
            <div className="row second_row mt-3">
              <h1>{overall_ratting}</h1>
              <p
                className="mb-0 text-center d-flex"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {renderStars(overall_ratting)} &nbsp;{" "}
              </p>
            </div>
          
            

              {productDetails?.review?.length >= 2 ? (
                <>
                  <div className="row mt-3">
                  <Slider {...settings}>
                    {productDetails.review.map((item, index) => {
                      return (
                        <div className="grid_col" key={index}>
                          <div className="inner-box">
                            <div className="client_heading">
                              <h6
                                style={{
                                  display: "inline-block",
                                  marginBottom: "0px",
                                }}
                              >
                                {item.username} &nbsp;
                              </h6>

                              <div className="star-rating">
                                {renderStars(item.ratting)}
                              </div>
                            </div>

                            <div className="content_box">
                              <p>{item.comment}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                  </div>
                </>
              ) : (
                productDetails.review.map((item, index) => {
                  return (
                    <div className="row mt-3" style={{justifyContent:'center'}}>
                    <div
                      className="grid_col col-lg-4 col-md-6 col-sm-12"
                      key={index}
                    >
                      <div className="inner-box">
                        <div className="client_heading">
                          <h6
                            style={{
                              display: "inline-block",
                              marginBottom: "0px",
                            }}
                          >
                            {item.username} &nbsp;
                          </h6>

                          <div className="star-rating">
                            {renderStars(item.ratting)}
                          </div>
                        </div>

                        <div className="content_box">
                          <p>{item.comment}</p>
                        </div>
                      </div>
                    </div>
                    </div>
                  );
                })
              )}
           
          </div>
        </section>
      ) : null}
    </>
  );
}

export default Reviewsandcomments;
